import { Component } from '@angular/core';

@Component({
  selector: 'app-information-inadmin',
  templateUrl: './information-inadmin.component.html',
  styleUrls: ['./information-inadmin.component.scss', '../../../../../assets/css/tabs.scss']
})
export class InformationInadminComponent {
  information = 0;
}
